<template>
  <a-modal title="选择销售出库单" class="outbound-order-modal" :visible="visible" @ok="onCofrim" @cancel="handleCancel">
    <div class="offer-order-modal-top">
      <a-row :gutter="24">
        <a-col :md="4" :sm="6">
          <a-range-picker v-model="dateValue" format="YYYY-MM-DD" @change="changeData" />
        </a-col>
        <a-col :md="4" :sm="6">
          <a-tooltip>
            <template slot="title" v-if="formData.contactCustomerName">
              <span>{{ formData.contactCustomerName }}</span>
            </template>
            <a-input placeholder="请输入往来单位" autoComplete="off" v-model="formData.contactCustomerName"
              @dblclick="btnReceiptModel" @pressEnter="btnReceiptModel"
              class="border-radius-input contact-customer-name-input">
              <a-tooltip slot="suffix" title="更多" @click="btnReceiptModel">
                <div style="height: 100%">
                  <img src="@/assets/image/gengduo.png" alt style="width: 12px;" />
                </div>
              </a-tooltip>
            </a-input>
          </a-tooltip>
        </a-col>
        <a-col :md="4" :sm="6">
          <a-select style="width: 100%;" placeholder="选择经办人" v-model="formData.transactorName"
            @change="selectAgentList">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in agentList" :key="index">
              <span>{{ item.name }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="4" :sm="6">
          <a-input placeholder="请输入编号/商品名称/拼音" v-model="formData.keyword" />
        </a-col>
        <a-col :md="4" :sm="6" class="button-ant-col">
          <a-button class="ant-btn-color border-arc" @click="btnInquire">查询</a-button>
          <a-button class="border-arc" @click="btnResetData">重置</a-button>
        </a-col>
      </a-row>
    </div>
    <a-table :loading="{  spinning: $store.state.tabLoding, indicator:indicator }" :columns="columns" :dataSource="dataSource"
      :pagination="ipagination" bordered @showSizeChange="onShowSizeChange" @change="onChangeIpagination"
      :customRow="rowClick" :scroll="{y: 380 }"
      :row-selection="{ type: 'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange}">
      <!-- 单据编号 -->
      <template slot="code" slot-scope="text">
        <a-tooltip>
          <template slot="title" v-if="text">
            <span>{{ text }}</span>
          </template>
          <div class="text-overflow"> {{ text }}</div>
        </a-tooltip>
      </template>
      <!-- 购货单位 -->
      <template slot="contactCustomerName" slot-scope="text">
        <a-tooltip>
          <template slot="title" v-if="text">
            <span>{{ text }}</span>
          </template>
          <div class="text-overflow"> {{ text }}</div>
        </a-tooltip>
      </template>
      <!-- 摘要 -->
      <template slot="digest" slot-scope="text">
        <a-tooltip>
          <template slot="title" v-if="text">
            <span>{{ text }}</span>
          </template>
          <div class="text-overflow"> {{ text }}</div>
        </a-tooltip>
      </template>
    </a-table>
    <!-- 选择往来单位 -->
    <receipt-model ref="receipt" :warmPrompt="true" @onSelectModel="onSelectModel"></receipt-model>
  </a-modal>
</template>
<script>
import receiptModel from "@/components/receiptModel.vue";
import { getListMethod } from "@/utils/api";
import { tableWidth } from "@/mixins/tableWidth";
export default {
  name: "outboundOrder",
  mixins: [tableWidth],
  components: {
    receiptModel,
  },
  data() {
    return {
      visible: false,
      columns: [
        {
          defaultWidth: 180,
          title: "单据编号",
          dataIndex: "code",
          key: "code",
          ellipsis: true,
          scopedSlots: { customRender: "code" },
        },
        {
          title: "单据日期",
          dataIndex: "voucherDate",
          key: "voucherDate",
          ellipsis: true,
        },
        {
          defaultWidth: 180,
          title: "购货单位",
          dataIndex: "contactCustomerName",
          key: "contactCustomerName",
          ellipsis: true,
          scopedSlots: { customRender: "contactCustomerName" },
        },
        {
          title: "经办人",
          dataIndex: "transactorName",
          key: "transactorName",
          ellipsis: true,
        },
        {
          title: "单据金额",
          dataIndex: "totalAmount",
          key: "totalAmount",
          ellipsis: true,
        },
        {
          defaultWidth: 180,
          title: "摘要",
          dataIndex: "digest",
          key: "digest",
          ellipsis: true,
          scopedSlots: { customRender: "digest" },
        },
      ],
      formData: {
        contactCustomerName: undefined,
        transactorName: undefined,
        transactorId: null,
        contactCustomerId: null,
        keyword: null,
        startTime: null,
        endTime: null,
      },
      selectedRowKeys: [],
      selectedRow: [],
      dataSource: [],
      contactCustomerId: "",
      urlList: {
        list: "/storage/api/voucher/pageVoucher",
      },
      dateValue: null,
      voucherId: [],
      goodsList: [],
      selectVoucherId: [],
      isLoding: false,
      agentList: [],
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      ipagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total, range) => {
          return `共 ${total}条数据  每页${range[1] - range[0] + 1}条`;
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
    };
  },
  methods: {
    open(data) {
      this.visible = true;
      this.selectedRowKeys = [];
      this.selectedRow = [];
      this.selectVoucherId = data.selectVoucherId;
      this.formData.contactCustomerName = data.contactCustomerName;
      this.formData.contactCustomerId = data.contactCustomerId;
      this.agentList = data.agentList;
      this.getGoodsList();
    },
    handleCancel() {
      this.visible = false;
    },
    onSelectChange(selectedRowKeys, selectedRow) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRow = selectedRow;
      this.dataId = selectedRow[0].voucherEntityId;
    },
    onCofrim() {
      this.visible = false;
      this.$emit("btnOnCofrim", this.dataId, 4);
    },
    // 页面变化时回调
    onChangeIpagination(current) {
      this.ipagination.current = current.current;
      this.ipagination.pageSize = current.pageSize;
      this.getGoodsList();
    },
    // 一页显示条数变化时回调
    onShowSizeChange(current, pageSize) {
      this.ipagination.current = current;
      this.ipagination.pageSize = pageSize;
      this.getGoodsList();
    },
    // 选择筛选日期
    changeData(date, dateString) {
      this.dateValue = date;
      this.formData.startTime = dateString[0];
      this.formData.endTime = dateString[1];
    },
    // 选择往来单位
    btnReceiptModel() {
      this.$refs.receipt.onOpen(this.formData.contactCustomerName);
    },
    onSelectModel(data) {
      this.formData.contactCustomerId = data.id;
      this.formData.contactCustomerName = data.contactCustomerName
        ? data.contactCustomerName
        : data.contactName;
    },
    // 选择经办人
    selectAgentList(e) {
      this.formData.transactorId = this.agentList[e].id;
      this.formData.transactorName = this.agentList[e].name;
    },
    // 点击整行
    rowClick(record, index) {
      return {
        on: {
          click: () => {
            this.selectedRowKeys = [index];
            this.dataId = record.voucherEntityId;
          },
          dblclick: () => {
            this.selectedRowKeys = [index];
            this.dataId = record.voucherEntityId;
            this.onCofrim();
          },
        },
      };
    },
    // 重置数据
    btnResetData() {
      this.dateValue = null;
      this.ipagination.current = 1;
      this.ipagination.pageSize = 10;
      this.formData = {
        contactCustomerName: undefined,
        transactorName: undefined,
      };
      this.getGoodsList();
    },
    // 筛选
    btnInquire() {
      this.ipagination.current = 1;
      this.ipagination.pageSize = 10;
      this.getGoodsList();
    },
    // 获取表格数据
    getGoodsList() {
      this.$store.state.tabLoding = true;
      let url = this.urlList.list;
      let params = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
        contactCustomerId: this.formData.contactCustomerId,
        transactorId: this.formData.transactorId,
        digest: this.formData.digest,
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
        keyword: this.formData.keyword,
        type: 5,
        state: 3,
      };
      let data = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      };
      getListMethod(url, params, {}, data).then((res) => {
        if (res.success) {
          this.$store.state.tabLoding = false;
          this.dataSource = res.result.records;
          this.ipagination.total = parseInt(res.result.total);
        }
      });
    },
  },
  watch: {
    "formData.contactCustomerName"() {
      if (this.formData.contactCustomerName.length <= 0) {
        this.formData.contactCustomerId = "";
      }
    },
  },
};
</script>
<style lang="scss">
.outbound-order-modal {
  width: 1200px !important;
  height: 780px !important;

  .ant-table-wrapper {
    height: 520px;
    .ant-table {
      height: 460px;
      .ant-modal-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .ant-modal-body {
        padding: 0px 24px 0px 24px !important;
        .ant-table-tbody {
          td {
            background: #ffffff !important;
          }
        }
      }
    }
  }

  .text-overflow {
    width: 100%;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ant-modal-footer {
    padding: 0 0 30px 0;
  }
  .offer-order-modal-top {
    padding: 0 0 20px 0;
    .button-ant-col {
      display: flex;
      justify-content: space-between;
      .border-arc {
        width: 80px !important;
      }
    }
  }
}
</style>